import {
  IActivityBase,
  IActivityItemBase,
  IActivityScheduleBase,
} from '../../models/activities';
import { ISpotBase, ISpotModalityBase } from '../../models/spots';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IShowExternalLinkActivitySchedulesActivity
  extends IActivityBase {
  items: IActivityItemBase[];
  spot: ISpotBase;
}

export interface IShowExternalLinkActivitySchedule
  extends IActivityScheduleBase {
  activity: IShowExternalLinkActivitySchedulesActivity;
  modality?: ISpotModalityBase;
}

export const showExternalLinkActivitySchedulesService = async (
  scheduleId: string,
): Promise<IShowExternalLinkActivitySchedule> => {
  const { data } = await jhsfBookingsApi.get<IShowExternalLinkActivitySchedule>(
    `/activities/schedules/${scheduleId}/external-link`,
  );

  return data;
};
